import TextField, { TextFieldProps } from '@mui/material/TextField';
import React, { ReactNode } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import isEmpty from 'lodash/isEmpty';
import IconButton from '@mui/material/IconButton';
import C from './SearchInputField.css';
import cc from 'classcat';
import { msg } from '@lingui/macro';
import { useLingui } from '@lingui/react';

export default function SearchInputField(
  p: TextFieldProps & {
    onClear?: () => void;
    tags?: ReactNode[];
    placeholder?: string;
  },
) {
  const { _ } = useLingui();
  return (
    <TextField
      variant='filled'
      placeholder={p.placeholder || _(msg`Search`)}
      {...p}
      className={cc([p.className, C.searchField])}
      style={{
        borderRadius: '4px',
        border: '0.75px solid var(--color-border)',
        ...p.style,
      }}
      InputProps={{
        startAdornment: (
          <>
            <SearchIcon
              style={{
                opacity: 0.5,
                height: '16px',
                width: '16px',
                marginRight: '8px',
              }}
            />
            {p.tags}
          </>
        ),
        style: {
          background: 'white',
          borderRadius: '4px',
          fontSize: 'var(font-size-subtext)',
          color: 'var(--color-subtext)',
          ...p.InputProps?.style,
        },
        endAdornment:
          !p.onClear || isEmpty(p.value) ? null : (
            <IconButton
              onClick={() => {
                p.onClear?.();
              }}
              size='small'
            >
              <CloseIcon />
            </IconButton>
          ),
        ...p.InputProps,
      }}
    />
  );
}
